import { render, staticRenderFns } from "./choiceDeviceRelation.vue?vue&type=template&id=c78aff9e&scoped=true&"
import script from "./choiceDeviceRelation.vue?vue&type=script&lang=js&"
export * from "./choiceDeviceRelation.vue?vue&type=script&lang=js&"
import style0 from "./choiceDeviceRelation.vue?vue&type=style&index=0&id=c78aff9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78aff9e",
  null
  
)

export default component.exports